import { useAuth0 } from "@auth0/auth0-react";
import React, { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { DarkModeContext } from "../../appContexts/DarkModeContext";
import { DisplayMobileSidebarContext } from "../../appContexts/DisplayMobileSidebarContext";
import { Icon_Admin } from "../../images/icons/Icon_Admin";
import { Icon_Home } from "../../images/icons/Icon_Home";

export const MobileNavigatorFC = () => {
  const { darkMode } = useContext(DarkModeContext);
  const { setDisplayMobileSidebar } = useContext(DisplayMobileSidebarContext);
  const { isLoading, isAuthenticated } = useAuth0();
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleNavClick = () => {
    setDisplayMobileSidebar(false);
  };

  return (
    <MobileNavigatorSC>
      <NavItem>
        <NavLink to="/" onClick={handleNavClick} $active={isActive("/")}>
          <IconWrapper $active={isActive("/")}>
            <Icon_Home />
          </IconWrapper>
          <NavText>Home</NavText>
          {isActive("/") && <ActiveDot />}
        </NavLink>
      </NavItem>

      {isAuthenticated && (
        <NavItem>
          <NavLink
            to="/admin"
            onClick={handleNavClick}
            $active={isActive("/admin")}
          >
            <IconWrapper $active={isActive("/admin")}>
              <Icon_Admin />
            </IconWrapper>
            <NavText>Admin</NavText>
            {isActive("/admin") && <ActiveDot />}
          </NavLink>
        </NavItem>
      )}
    </MobileNavigatorSC>
  );
};

const MobileNavigatorSC = styled.nav`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  gap: 8px;
  overflow-y: auto;
`;

const NavItem = styled.div`
  width: 100%;
`;

const NavLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  text-decoration: none;
  border-radius: 12px;
  position: relative;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  background: ${({ $active }) =>
    $active
      ? "linear-gradient(135deg, rgba(44, 90, 160, 0.15) 0%, rgba(52, 152, 219, 0.1) 100%)"
      : "transparent"};

  &:hover {
    background: linear-gradient(
      135deg,
      rgba(44, 90, 160, 0.1) 0%,
      rgba(52, 152, 219, 0.05) 100%
    );
    transform: translateX(4px);
  }

  &:active {
    transform: translateX(2px) scale(0.98);
  }
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: ${({ $active }) =>
    $active ? "rgba(44, 90, 160, 0.15)" : "rgba(44, 90, 160, 0.08)"};
  color: ${({ $active }) => ($active ? "#2c5aa0" : "rgba(44, 90, 160, 0.7)")};
  transition: all 0.2s;

  svg {
    width: 20px;
    height: 20px;
  }

  ${NavLink}:hover & {
    background: rgba(44, 90, 160, 0.2);
    color: #2c5aa0;
  }
`;

const NavText = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #2c5aa0;
  flex: 1;
`;

const ActiveDot = styled.div`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, #2c5aa0 0%, #3498db 100%);
  box-shadow: 0 2px 6px rgba(44, 90, 160, 0.4);
`;
